import AlarmAPI from '../AlarmAPI';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  ALARMS_POLLING_INTERVAL,
  AlarmsQueryParamsAPIRequest,
  AlarmState,
  excludedEventIdsStr,
} from '../Alarm.model';
import { patchLoadingState } from '../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';

type Options = Parameters<UseQuerySubscription<any>>[1];

function useAlarmsByWorkspace(
  workspaceId: string | undefined,
  params?: AlarmsQueryParamsAPIRequest,
  options: Options = {}
) {
  const { data: alarmsData, ...restAlarmAPI } =
    AlarmAPI.useGetFlexeserveIncidentByWorkspaceIdQuery(
      {
        workspaceId: workspaceId || '',
        params: {
          state: AlarmState.NEW,
          page_size: 1000,
          excluded_event_ids: excludedEventIdsStr,
          ...params,
        },
      },
      {
        skip: !workspaceId,
        pollingInterval: ALARMS_POLLING_INTERVAL,
        ...options,
      }
    );

  return {
    ...patchLoadingState(restAlarmAPI),
    allAlarms: alarmsData?.data,
    count: alarmsData?.count ?? 0,
    data: alarmsData?.data ?? [],
  };
}

export default useAlarmsByWorkspace;
